import './lib/burger.js';
import './lib/pagetop.js'; // Pagetop





// ナビゲーションリセット
window.addEventListener('resize', () => {
  document.querySelector('[data-nav-toggle="true"]').setAttribute('aria-pressed', 'false');
  document.getElementById('pageNavigation').setAttribute('aria-disabled', 'true');
  document.body.style.overflow = 'auto';
});



/**
***  accordion  */
(function(){
  // アコーディオンの親要素のクラス名
  const accordionParentClassName = '.accordion';
  // アコーディオンのクリックイベントを行うクラス名
  const triggerClassName = '.js-accordion-trigger';
  // アコーディオンを開くためのクラス名
  const activeClassName = 'active';

  // アコーディオンのトリガーをすべて取得する
  const acc = document.querySelectorAll(triggerClassName);

  // クリックイベント
  for ( let i = 0; i < acc.length; i++ ){
    acc[i].addEventListener('click', function(e){
      // アクティブクラスが付いているかチェックする
      const isActive = this.classList.contains(activeClassName);
      // クリックした要素のアコーディオンの親要素を取得する
      const parentAccordion = this.closest(accordionParentClassName);

      // すべてのアコーディオンを閉じる
      const allAccordions = parentAccordion.querySelectorAll(triggerClassName);
      for ( let j = 0; j < allAccordions.length; j++) {
        // Remove active class from section header
        allAccordions[j].classList.remove(activeClassName);
        // Remove the max-height class from the panel to close it
        const panel = allAccordions[j].nextElementSibling;
        const maxHeightValue = getStyle(panel, 'maxHeight');

        if (maxHeightValue !== '0px') {
          panel.style.maxHeight = null;
        };
      };

      // アクティブクラスの付け替え
      isActive ? this.classList.remove(activeClassName) : this.classList.add(activeClassName);

      // アコーディオンの開閉処理
      const panel = this.nextElementSibling;
      const maxHeightValue = getStyle( panel, 'maxHeight' );
      if (maxHeightValue !== '0px') {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      };
    });
  }
}());



/**
***  tab  */
(function(){
  // タブ処理を行う要素のクラス名
  const tabsClass            = 'js-tab';
  const currentClassName     = 'js-tab-current';
  const currentViewClassName = 'js-tab-current-view';
  // タブ処理を行う要素の取得
  const tabs = document.getElementsByClassName(tabsClass);
  // ない場合はなにもしない
  if( !tabs ){ return; }

  // Click event
  for (let i = 0; i < tabs.length; i++){
    tabs[i].addEventListener('click', function(){
      // データ属性を取得する
      const view = this.dataset.view;
      // .current が付与しているかチェック
      const isCurrent = this.classList.contains(currentClassName);
      // クリックしたタブの親要素を取得する
      const tabsParent = this.parentNode.parentNode.parentNode;
      // 他のタブ要素に影響しないようにクリックしたタブ要素だけに絞る
      const tabsChild = tabsParent.getElementsByClassName(tabsClass);
      // コンテンツの要素を取得する
      const allContents = tabsParent.getElementsByClassName('js-contents');

      if (!isCurrent) {
        // remove .current
        for ( let j = 0; j < tabsChild.length; j++ ){
          tabsChild[j].classList.remove(currentClassName);
        };
        this.classList.add(currentClassName);
      };
      // remove .current-view
      for ( let k = 0; k < allContents.length; k++ ){
        allContents[k].classList.remove(currentViewClassName);
      };
      //
      document.getElementById(view).classList.add(currentViewClassName);
    });
  };
}());



/**
***  ページ内リンク  */
(function(){
  const elm = document.querySelectorAll('.js-page-anchor');
  // ない場合はなにもしない
  if( ! elm.length ){ return; };
  // イベント
  for ( let i = 0; i < elm.length; i++) {
    elm[i].addEventListener( 'click', function(e){
      e.preventDefault();
      const href = this.getAttribute('href');
      // ページ内リンクでない場合は何もしない
      if( href.slice(0, 1) != '#' ){
        return;
      };
      // リンク先の要素を取得
      const pageID = document.getElementById(href.slice(1));
      // ない場合はなにもしない
      if( !pageID ){ return; };
      const rect = pageID.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const position = rect.top + scrollTop;
      // スクロール処理
      window.scrollTo({
        top: position - 16,
        left: 0,
        behavior: 'smooth'
      });
    });
  }
}());



/**
***  指定したプロパティを要素から取得する  */
const getStyle = (el, styleProp) => {
  let defaultView = ( el.ownerDocument || document ).defaultView;
  styleProp = styleProp.replace(/([A-Z])/g, '-$1').toLowerCase();
  return defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
};



/**
***  Grobal Menu Event  */
/*
(function(){
  // グローバルナビゲーションの要素
  const globalNav = document.getElementById('globalNav');

  // すべてのトリガーを取得する
  const allTrigger = globalNav.querySelectorAll('.js-trigger');

  // 幅が lg 以上のビューポートをターゲットとするメディアクエリを作成
  const mediaQuery = window.matchMedia('(min-width: 992px)');

  // アクティブクラスが付いているかチェックする
  const activeClassName = 'active';

  // ホバー時に付与するクラス名
  const hoverClassName = 'hover';

  // Window width
  let memoryWindowWidth = window.innerWidth;


  // イベント
  allTrigger.forEach( elm => {
    // クリックイベント
    elm.addEventListener('click', function(t){
      // PCでの処理
      if( mediaQuery.matches ){
        return;
      } else {
        // モバイルでの処理
        t.preventDefault();
        // アクティブ判定
        const isActive = this.parentNode.classList.contains(activeClassName);

        // 一度、すべてのメニューを閉じる
        allTrigger.forEach( child => {
          // 高さを取得する要素（クリックした要素の子メニュー）
          const panel = child.nextElementSibling;
          //const maxHeightValue = getStyle(panel, 'maxHeight');
          if( child !== this ){
            child.parentNode.classList.remove(activeClassName);
            panel.style.maxHeight = null;
          }
        });
        // アクティブクラスの処理
        isActive ? this.parentNode.classList.remove(activeClassName) : this.parentNode.classList.add(activeClassName);
        // 子メニューの開閉処理
        // Toggle the panel element
        const panel = this.nextElementSibling;
        const maxHeightValue = getStyle( panel, 'maxHeight' );
        if (maxHeightValue !== '0px') {
          panel.style.maxHeight = null;
          return;
        }
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });

    // PC時のホバー処理
    elm.parentNode.addEventListener( 'mouseenter', () => {
      if( mediaQuery.matches ){
        elm.parentNode.classList.add( hoverClassName );
        elm.nextElementSibling.style.maxHeight = elm.nextElementSibling.scrollHeight + 'px';
      }
    });
    elm.parentNode.addEventListener( 'mouseleave', () => {
      if( mediaQuery.matches ){
        elm.parentNode.classList.remove( hoverClassName );
        elm.nextElementSibling.style.maxHeight = null;
      }
    });

  });
  // window リサイズでメニューをクリアにする処理
  window.addEventListener( 'resize', function(){
    if( memoryWindowWidth !== window.innerWidth ){
      // window の width を取得し直す
      memoryWindowWidth = window.innerWidth;
      allTrigger.forEach( el => {
        // 子メニューを閉じる
        el.parentNode.classList.remove(activeClassName);
        const panel = el.nextElementSibling;
        panel.style.maxHeight = null;
      });
      // バーガーを閉じる
      this.document.body.classList.remove('visible-mobile-menu');
    }
  });
}());
*/
